import api from "@/store/api.js";
import Message from "@/store/messages";
import pagination from "@/store/pagination";
import { required } from "vuelidate/lib/validators";

const organizers = {
  namespaced: true,
  modules: {
    pg: pagination,
  },
  state: () => ({
    list: [],
    dropdown: [],
    current: null,
    create: {
      name: "",
    },
  }),
  mutations: {
    create(state, value) {
      state.create = value;
    },
    current(state, value) {
      state.current = value;
    },
    list(state, value) {
      state.list = value;
    },
    dropdown(state, value) {
      var selectList = [];
      value
        ? value.forEach((row, index) => {
            selectList[index] = {
              title: row["name"],
              label: row["name"],
              value: row["id"],
            };
          })
        : null;
      state.dropdown = selectList;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    current(state) {
      return state.current;
    },
    organizerList(state) {
      return state.dropdown;
    },
    validations() {
      return {
        value: {
          name: { required },
        },
      };
    },
  },
  actions: {
    async create({ dispatch }) {
      await dispatch({ type: "createReq" });
      await dispatch({ type: "list" });
    },
    async update({ dispatch }) {
      await dispatch({ type: "updateReq" });
      await dispatch({ type: "list" });
    },
    async delete({ dispatch }, data) {
      await dispatch({ type: "deleteReq", data: data.data });
      await dispatch({ type: "list" });
    },
    createReq({ commit, state }) {
      return new Promise((resolve, reject) => {
        api
          .post("/events/organizer", state.create)
          .then((response) => {
            commit("current", null);
            commit(
              "currentMsg",
              Message.getMessage("success", "organizer.created"),
              { root: true }
            );
            resolve(response.data.payload);
          })
          .catch((error) => {
            commit("currentMsg", Message.getMessage("error", "error.unknown"), {
              root: true,
            });
            reject(error);
          });
      });
    },
    updateReq({ commit, state }) {
      return new Promise((resolve, reject) => {
        api
          .put("/events/organizer", state.current)
          .then((response) => {
            commit("current", null);
            commit(
              "currentMsg",
              Message.getMessage("success", "organizer.updated"),
              { root: true }
            );
            resolve(response.data.payload);
          })
          .catch((error) => {
            commit("currentMsg", Message.getMessage("error", "error.unknown"), {
              root: true,
            });
            reject(error);
          });
      });
    },
    deleteReq({ commit }, data) {
      return new Promise((resolve, reject) => {
        api
          .delete("/events/organizer/" + data.data)
          .then(() => {
            commit("current", null);
            commit(
              "currentMsg",
              Message.getMessage("success", "organizer.deleted"),
              { root: true }
            );
            resolve();
          })
          .catch((error) => {
            commit("currentMsg", Message.getMessage("error", "error.unknown"), {
              root: true,
            });
            reject(error);
          });
      });
    },
    list({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .get("/events/organizer")
          .then((response) => {
            commit("list", response.data.payload ? response.data.payload : []);
            commit("dropdown", response.data.payload);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
export default organizers;
